<template>
  <!-- <img height="40px" src="/img/logo_treed_v1.svg" alt="logo" /> -->
  <LoginLayout>
    <template v-slot:body>
      <div class="login-container">
        <h1 class="text-center mb-5">
          <br />
          반가워요!
        </h1>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row class="d-flex flex-column mt-7">
            <c-text-field
              ref="emailInput"
              class="mt-2"
              label="아이디"
              placeholder="이메일 주소 입력"
              type="email"
              width="354px"
              height="50px"
              v-model="loginEmail"
              :error="emailError"
              :errorMsg="emailErrorMsg"
              @enter="validate"
              @input="emailInput"
              @blur="emailFocusOut"
              @focus="emailFocusIn"
            />
          </v-row>
          <v-row class="d-flex flex-column mt-8 mb-5">
            <c-text-field
              class="mt-2"
              label="비밀번호"
              placeholder="비밀번호 입력"
              type="password"
              width="354px"
              height="50px"
              v-model="loginPassword"
              :error="passwordError"
              :errorMsg="passwordErrorMsg"
              @enter="validate"
              @input="pwdKeyUp"
              @blur="pwdFocusOut"
              @focus="pwdFocusIn"
            />
          </v-row>
        </v-form>
        <v-row class="mt-10">
          <c-btn
            class="blue-primary"
            width="354px"
            height="50px"
            fontSize="14px"
            fontWeight="500"
            fill
            :disabled="!emailCheck || !passwordCheck"
            @click="validate"
          >
            로그인
          </c-btn>
        </v-row>
        <v-row class="mt-6">
          <c-btn
            class="blue-primary"
            width="354px"
            height="50px"
            fontSize="14px"
            fontWeight="500"
            @click="signUp"
          >
            회원가입
          </c-btn>
        </v-row>
        <v-row v-if="errorCount" class="mt-6">
          <span class="t-caption tc-666" style="margin-left: 10%">
            계속 로그인이 되지 않는다면 매니저나 슈퍼바이저에게 문의하세요.
          </span>
        </v-row>

        <v-row class="justify-center">
          <div class="find-ID-PW" @click="findUser">
            아이디/비밀번호를 잊었어요!
          </div>
        </v-row>
      </div>
    </template>
  </LoginLayout>
</template>

<script>
import Util from "@/common/util";

import LoginLayout from "@/components/Layouts/LoginLayout.vue";

import TextField from "@/components/designSystem/CInputField.vue";
import CButton from "@/components/designSystem/CButton.vue";

export default {
  name: "Login",
  components: {
    LoginLayout,
    "c-text-field": TextField,
    "c-btn": CButton,
  },
  data() {
    return {
      valid: true,
      loginEmail: "",
      loginPassword: "",

      openDuplicateLogin: false,

      emailCheck: false,
      emailError: false,
      emailErrorMsg: "",

      passwordCheck: false,
      passwordError: false,
      passwordErrorMsg: "",

      errorCount: 0,
      forceLogin: false,

      regexDict: {
        includeLower: /.*[a-z]+.*$/,
        includeNumber: /.*[0-9]+.*$/,
        longerThan8: /^.{8,}$/,
      },
    };
  },
  methods: {
    emailInput() {
      this.$nextTick(() => {
        this.loginEmail = this.loginEmail
          .trim()
          .replace(/[^a-zA-Z0-9!@#$%^&*()_+{}[\]:;<>,.?~\\-]/g, "");

        this.checkEmail();
        this.emailError = false;
        this.emailErrorMsg = "";
      });
    },
    async clickLogin() {
      const payload = {
        email: this.loginEmail,
        hash: this.loginPassword,
        forceLogin: this.forceLogin,
      };
      const result = await this.$store.dispatch("auth/logIn", payload);

      // 다른 PC 에 로그인되어 있음
      if (result.code === "TK0002") {
        this.$store.commit("common/openGlobalModal", {
          content: `현재 접속 중인 계정입니다.\n지금 로그인 하시면\n다른 PC에서는 자동으로 로그아웃 됩니다.\n로그인 하시겠습니까?`,
          positiveOptions: { name: "로그인" },
          negativeOptions: { name: "취소" },
          positiveFn: this.setForceLogin,
        });
        return;
      }

      // 비밀번호 불일치
      if (result.code === "L0002") {
        this.passwordError = true;
        this.passwordErrorMsg = "비밀번호가 틀립니다.";
        this.errorCount++;
        return;
      } else {
        this.passwordErrorMsg = "";
      }

      // 신규 생성한 계정
      if (result.code === "L0004") {
        this.$router.push(
          "/register?email=" + this.loginEmail + "&key=" + result.authKey
        );
        return;
      }

      // 비밀번호 초기화
      if (result.code === "L0006") {
        this.$router.push(
          "/password?userId=" + result.user.id + "&email=" + this.loginEmail
        );
        return;
      }

      let errorContent = Util.checkLoginCode(result.code);
      if (errorContent === "") {
        this.$router.push("/");
      } else {
        this.emailError = true;
        this.emailErrorMsg = errorContent;
        // this.$store.commit("common/openGlobalModal", {
        //   content: errorContent,
        //   icon: "warn",
        // });
        this.errorCount++;
      }
    },
    setForceLogin() {
      this.forceLogin = true;
      this.clickLogin();
    },
    signUp() {
      this.$router.push("/signup");
    },
    findUser() {
      this.$router.push("/finduser");
    },
    emailFocusIn() {
      this.emailError = false;
      this.emailErrorMsg = "";
    },
    emailFocusOut() {
      this.checkEmail();
    },
    checkEmail() {
      if (this.loginEmail.trim().length <= 0) {
        return;
      }
      const email = this.validateEmail(this.loginEmail.trim());

      if (!email) {
        this.emailError = true;
        this.emailErrorMsg = "이메일 형식을 확인해 주세요.";
        this.emailCheck = false;
      } else {
        this.emailError = false;
        this.emailCheck = true;
      }
    },
    validateEmail(email) {
      const emailRegex =
        /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/;
      return emailRegex.test(email);
    },
    pwdKeyUp(input) {
      const check = this.checkPassword(input);

      this.passwordCheck = check.allCheck;
      this.passwordError = false;
      this.passwordErrorMsg = "";
    },
    checkPassword(input) {
      const includeLower = this.regexDict.includeLower.test(input);
      const includeNumber = this.regexDict.includeNumber.test(input);
      const longerThan8 = this.regexDict.longerThan8.test(input);

      return {
        allCheck: includeLower && includeNumber && longerThan8,
      };
    },
    pwdFocusIn() {
      this.passwordError = false;
      this.passwordErrorMsg = "";
    },
    pwdFocusOut() {
      if (this.loginPassword.trim().length <= 0) {
        return;
      }

      if (this.passwordCheck) {
        this.passwordError = false;
        this.passwordCheck = true;
      } else {
        this.passwordError = true;
        this.passwordErrorMsg = "잘못된 비밀번호에요.";
        this.passwordCheck = false;
      }
    },
    validate() {
      this.checkEmail();
      this.pwdFocusOut();

      if (this.emailCheck && this.passwordCheck) this.clickLogin();
    },
  },
  computed: {
    token() {
      return this.$store.state.auth.token;
    },
  },
  watch: {},
  created() {},
  async mounted() {
    this.$store.commit("history/clearHistory");

    if (this.token) {
      await this.$store.dispatch("auth/logOut");
    }

    const el = this.$refs.emailInput.$el.querySelector("input[type='email']");
    el.focus();
  },
  updated() {},
  destroyed() {},
};
</script>

<style scoped>
label {
  font-weight: 500 !important;
}

.text-center {
  text-align: left !important;
  font-weight: 900 !important;
  font-size: 50px;
  margin-left: -15px;
}

.find-ID-PW {
  text-decoration-line: underline;
  --tw-text-opacity: 1;
  color: rgb(153 153 153 / var(--tw-text-opacity));
  font-size: 12px;
  margin-top: 30px;
  cursor: pointer;
}

.login-container {
  width: 354px;
  height: 100%;
  justify-content: flex-start;
  flex-direction: column;
  display: flex;
  position: relative;
}
</style>
